module.exports = __webpack_public_path__ + "img/connect-by-happiness_2.26594d14.png";